export function LLHeadCompose(page, rowL, ll, dataUrl) {
    var doc = ll;
    var _y = rowL;
    // var _space = page.spacingunit;

    var imageX = 210;

    doc.addImage(dataUrl, 'JPEG', imageX, page.headerFromTop, 55, 25);
    return _y;
}

export function LLBodyCompose(page, rowL, ll, data) {
    var doc = ll;
    var _y = rowL;
    var _space = page.spacingunit;

    let current_datetime = new Date()
    let formatted_date = (current_datetime.getMonth() + 1) + "/" + current_datetime.getDate() + "/" + current_datetime.getFullYear();
    var origin = GetUniqueOrigin(data.voyageBranches)
    var destination = GetUniqueDestination(data.voyageBranches)
    var vessel = GetUniqueVessel(data.voyageBranches)
    var voyage = GetUniqueVoyage(data.voyageBranches)
    var actualVessel = GetUniqueActualVessel(data.voyageBranches)
    var voyageRemark = GetUniqueVoyageRemark(data.voyageBranches)

    doc.setFont("times", "bold");
    doc.text('OCEAN TRANSPORT GROUP OF COMPANIES INC.', 150, _y, null, null, 'center');
    doc.setFont("times", "normal");

    _y += _space;
    doc.text('LOAD LIST', 150, _y, null, null, 'center');

    _y += _space;
    doc.text(origin[0] + ' – ' + destination.join(' - '), 150, _y, null, null, 'center');
    _y += _space;
    doc.text('Voyage Sequence: ' + voyage[0], 150, _y, null, null, 'center');
    _y += _space;
    doc.text('Planned Vessel/Voyage Ref: ' + vessel[0] + ' ' + voyageRemark[0], 150, _y, null, null, 'center');
    if (actualVessel[0] !== null) {
        _y += _space;
        doc.setFont("times", "bold");
        doc.text('Actual Vessel/Voyage Ref: ' + actualVessel[0] + ' ' + voyageRemark[0], 150, _y, null, null, 'center');
        doc.setFont("times", "normal");
    }
    doc.text(20, _y, 'Date : ' + formatted_date);
    _y += _space * 2;

    return _y;
}

export function LLTableCompose(page, rowL, ll, data) {
    var doc = ll;
    var _y = rowL;
    var _space = page.spacingunit;

    var newPage = false;

    doc.text(10, _y, 'Customer');
    doc.text(110, _y, 'Other');
    doc.line(10, _y + 1, 270, _y + 1);
    _y += _space;

    // eslint-disable-next-line
    data.wayBIll.map(d => {
        var splitShipper = doc.splitTextToSize(d.shipper ? d.shipper : '', 74);
        var splitShipperPreferredName = doc.splitTextToSize(d.shipperPreferedName ? d.shipperPreferedName : '', 68);
        var splitConsignee = doc.splitTextToSize(d.consignee ? d.consignee : '', 74);
        var splitConsigneePreferredName = doc.splitTextToSize(d.consigneePreferedName ? d.consigneePreferedName : '', 68);

        doc.text(10, _y, 'Shipper');
        doc.text(33, _y, ":");
        doc.text(36, _y, splitShipper);
        var C_y = 0;
        if (splitShipper.length > 1) {
            C_y = (_y + (_space * (splitShipper.length)));
        }
        else {
            C_y = _y + _space;
        }
        doc.text(10, C_y, 'Preferred Name');
        doc.text(40, C_y, ":");
        doc.text(42, C_y, splitShipperPreferredName);
        if (splitShipperPreferredName.length > 1) {
            C_y = (C_y + (_space * (splitShipperPreferredName.length)));
        }
        else {
            C_y = C_y + _space;
        }

        doc.text(10, C_y, 'Consignee');
        doc.text(33, C_y, ":");
        doc.text(36, C_y, splitConsignee);

        if (splitConsignee.length > 1) {
            C_y = (C_y + (_space * (splitConsignee.length)));
        }
        else {
            C_y = C_y + _space;
        }

        doc.text(10, C_y, 'Preferred Name');
        doc.text(40, C_y, ":");
        doc.text(42, C_y, splitConsigneePreferredName);

        var checkCommodity = d.goods ? d.goods : '';
        doc.text(110, _y, 'Commodity: ' + checkCommodity);
        var checkSeal = d.sealNum ? d.sealNum : ''
        doc.text(215, _y, 'Seal No: ' + checkSeal);
        _y += _space;


        var checkCW = d.cargoWeight ? d.cargoWeight : '0';
        doc.text(110, _y, 'Weight(Ton): ' + checkCW);
        var checkCargoType = d.cargoType ? d.cargoType : '';
        doc.text(170, _y, 'Cargo Type: ' + checkCargoType);
        var checkStatus = d.releaseType ? d.releaseType : '';
        doc.text(215, _y, 'Status: ' + checkStatus);
        _y += _space;

        var checkWaybill = d.wayBillRef ? d.wayBillRef : '';
        doc.text(110, _y, 'Waybill: ' + checkWaybill);
        var checkBooking = d.bookingRef ? d.bookingRef : '';
        doc.text(170, _y, 'Booking Ref: ' + checkBooking);

        // _y += _space;
        // var checkOldWaybill = d.oldWaybillRef ? d.oldWaybillRef : '';
        // doc.text(110, _y, 'Old Waybill: ' + checkOldWaybill);
        // var checkOldBooking = d.oldBookingRef ? d.oldBookingRef : '';
        // doc.text(170, _y, 'Old Booking Ref: ' + checkOldBooking);

        _y += _space;
        var checkVanNum = d.vanNumber ? d.vanNumber : '';
        doc.text(110, _y, 'Container #: ' + checkVanNum);
        var checkRemark = d.releaseTag ? d.releaseTag : '';
        doc.text(170, _y, 'Remarks: ' + checkRemark);

        var spaceShiCon = splitShipper.length + splitConsignee.length + splitShipperPreferredName.length +  splitConsigneePreferredName.length;
        if (spaceShiCon > 4) {
            _y += (_space * (spaceShiCon - 4));
        }
        doc.line(10, _y + 1, 270, _y + 1);
        _y += _space;

        // console.log(_y)
        if (_y >= 195) {
            doc.addPage(page.layoutL, page.papersize.unit, page.papersize.format);
            _y = 10;
            _y += _space * 2;
            newPage = true;

            if (newPage) {
                doc.text(10, _y, 'Customer');
                doc.text(110, _y, 'Other');
                doc.line(10, _y + 1, 270, _y + 1);
                _y += _space;
            }
        }
        else {
            newPage = false;
        }
    })
    return _y;
}

export function LLRevisionCompose(page, rowL, ll, data) {
    var doc = ll;
    var _y = rowL;
    var _space = page.spacingunit;
    var margin = 10;
    var headerY = rowL;

    doc.setFont("times", "bold");
    doc.text(margin, _y, 'Revision');
    doc.setFont("times", "normal");
    _y += _space * 2;

    doc.setFont("times", "bold");
    doc.text(margin, _y, 'Added');
    doc.setFont("times", "normal");
    _y += _space;

    doc.text(margin, _y, 'Booking Ref / Container Van');
    _y += _space;

    // eslint-disable-next-line
    data.revision.map(r => {
        // eslint-disable-next-line
        r.wayBill.filter(w => w.status === "added").map(wb => {
            doc.text(margin, _y, wb.containerVanNum);
            _y += _space;

            if (_y >= 195) {
                _y = headerY;
                margin += 70

                doc.setFont("times", "bold");
                doc.text(margin, _y, 'Added');
                doc.setFont("times", "normal");
                _y += _space;

                doc.text(margin, _y, 'Booking Ref / Container Van');
                _y += _space;

                if (margin >= 215) {
                    doc.addPage(page.layout, page.papersize.unit, page.papersize.format);
                    _y = rowL;
                    margin = 10;
                }
            }
        })
    })

    _y += _space;

    doc.setFont("times", "bold");
    doc.text(margin, _y, 'Removed');
    doc.setFont("times", "normal");
    _y += _space;

    doc.text(margin, _y, 'Booking Ref / Container Van');
    _y += _space;

    // eslint-disable-next-line
    data.revision.map(r => {
        // eslint-disable-next-line
        r.wayBill.filter(w => w.status === "removed").map(wb => {
            doc.text(margin, _y, wb.containerVanNum);
            _y += _space;

            if (_y >= 195) {
                _y = headerY;
                margin += 70

                doc.setFont("times", "bold");
                doc.text(margin, _y, 'Removed');
                doc.setFont("times", "normal");
                _y += _space;

                doc.text(margin, _y, 'Booking Ref / Container Van');
                _y += _space;

                if (margin >= 215) {
                    doc.addPage(page.layout, page.papersize.unit, page.papersize.format);
                    _y = rowL;
                    margin = 10;
                }
            }
        })
    })


}

export function GetUniqueOrigin(documents) {
    const result = [];
    const map = new Map();
    // eslint-disable-next-line
    for (const item of documents) {
        if (!map.has(item.originBranchName)) {
            map.set(item.originBranchName, true);    // set any value to Map
            result.push(item.originBranchName);
        }
    }
    return result;
}

export function GetUniqueVessel(documents) {
    const result = [];
    const map = new Map();
    // eslint-disable-next-line
    for (const item of documents) {
        if (!map.has(item.vessel)) {
            map.set(item.vessel, true);    // set any value to Map
            result.push(item.vessel);
        }
    }
    return result;
}

export function GetUniqueVoyageRemark(documents) {
    const result = [];
    const map = new Map();
    // eslint-disable-next-line
    for (const item of documents) {
        if (!map.has(item.remarks)) {
            map.set(item.remarks, true);    // set any value to Map
            result.push(item.remarks);
        }
    }
    return result;
}

export function GetUniqueActualVessel(documents) {
    const result = [];
    const map = new Map();
    // eslint-disable-next-line
    for (const item of documents) {
        if (!map.has(item.actualVessel)) {
            map.set(item.actualVessel, true);    // set any value to Map
            result.push(item.actualVessel);
        }
    }
    return result;
}

export function GetUniqueVoyage(documents) {
    const result = [];
    const map = new Map();
    // eslint-disable-next-line
    for (const item of documents) {
        if (!map.has(item.voyageNum)) {
            map.set(item.voyageNum, true);    // set any value to Map
            result.push(item.voyageNum);
        }
    }
    return result;
}

export function GetUniqueDestination(documents) {
    const result = [];
    const map = new Map();
    // eslint-disable-next-line
    for (const item of documents) {
        if (!map.has(item.destinationBranchName)) {
            map.set(item.destinationBranchName, true);    // set any value to Map
            result.push(item.destinationBranchName);
        }
    }
    return result;
}



